import React, { Component } from 'react';
import { Icon, Input, Button, message } from 'antd';
import axios from 'axios';

//Handles Login
class LoginForm extends Component {

  constructor(props){
    super(props);

    //Store form data in state
    this.state = {
      email: '',
      password: ''
    }
  }

  handleEmail(e){
    this.setState({ email: e.target.value });
  }

  handlePassword(e){
    this.setState({ password: e.target.value });
  }

  handleSubmit(e){
    //Check for empty fields
    if(this.state.email === '' ||
       this.state.password === ''){
         message.error("You have an empty field");
         return;
    }
    const {fetchUser} = this.props;

    //Ajax to login
    axios.post('/auth/login', {
      email: this.state.email,
      password: this.state.password
    }).then(function(response) {
      //Call function to update state
      message.success("You are now logged in.");
      fetchUser();
    }).catch(err => {
      const status = err.response ? err.response.status : null;
      //Error handling for bad password/email
      if(status == 401 || status == 400){
        message.error('Incorrect Email or Password');
      } else {
        console.log(err);
        message.error('Server Error');
      }
    });
  }

  render() {
    return (
      <div id="Login">
        <Input
          name="email"
          value={this.state.email}
          onChange = {(e) => this.handleEmail(e)}
          prefix={<Icon type="login" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email" />
        <Input
          name="password"
          onPressEnter={(e) => this.handleSubmit(e)}
          value={this.state.password}
          onChange = {(e) => this.handlePassword(e)}
          prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
        <Button icon="login" id="btn-login-form" onClick={(e) => this.handleSubmit(e)}>Login</Button>
      </div>
    );
  }
}


export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/Site/LoginForm.js